define(function (require) {
    var $ = require("jquery");

    $(document).ready(function () {
        $("#physicianDetailPdfLink").click(function () {
            window.open('/controller/PhysicianDetailPdf/Download?' + window.location.search.replace('?', '') + '&isSpecialist=' + $('#IsSpecialist').val() + '&contextItemId=' + window.scan.contextItemId, '_blank');
        });

        $("#formularyDetailPdfLink")
            .click(function () {
                var copayParams = "&Year=" + $("#copayYear").val() + "&State=" + $("#coPayState").val() + "&County=" + $("#coPayCounty").val() + "&Plan=" + $("#coPayPlan").val();
                var link = '/controller/FormularyDetailPdf/Download?' + window.location.search.replace('?', '') + '&contextItemId=' + window.scan.contextItemId + copayParams;
                window.open(link,'_blank');
            });
    });
});
